import {sendServerRequest} from './baseService';

export const settingService = {
    loadSettings,
};

async function loadSettings() {
    return sendServerRequest('GET', `/api/settings`);
}
